<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="chapter7">
<h1><a id="page_25"></a><a href="#/003toc#ch7">Triple Mushroom Soup</a></h1>
<p class="noindent">Three different types of mushrooms slow cook in a bacon-and-sage broth to deliver a delicious soup to serve as a main course or starter. Make sure to check the expiration date on your dried mushrooms; if they are old, chances are they will take away from the flavor of the soup.</p>
<p class="noindent">8 strips bacon, cut into ½-inch dice</p>
<p class="noindent">1 large onion, finely chopped</p>
<p class="noindent">1 teaspoon dried sage leaves, crushed in the palm of your hand</p>
<p class="noindent">1 pound cremini mushrooms, sliced</p>
<p class="noindent">1 pound shiitake mushrooms, stems removed, caps sliced</p>
<p class="noindent">1 ounce dried porcini mushrooms</p>
<p class="noindent">¼ cup soy sauce</p>
<p class="noindent">3 cups chicken broth</p>
<p class="noindent">1 cup heavy cream</p>
<p class="noindent">½ cup snipped fresh chives for garnishing</p>
<p class="noindent">saute the bacon in a large skillet over medium heat until crisp and remove it from the pan to drain.</p>
<p class="noindent">add the onion and sage to the pan and sauté until the onion is softened. Add the cremini and shiitake mushrooms and toss until the mixture is combined.</p>
<p class="noindent">transfer the contents of the skillet to the insert of a 5- to 7-quart slow cooker. Add the porcini mushrooms, soy sauce, broth, and bacon.</p>
<p class="noindent">cover and cook on high for 3 hours or on low for 5 to 6 hours. At the end of the cooking time, add the cream and stir to combine.</p>
<p class="noindent">serve the soup garnished with the chives.</p>
<p class="noindent">serves 8</p>
<hr/>
<p class="sidebar_head"><img alt="image 1" class="inline" src="images/image-01.jpg"/>slow-cooker savvy</p>
<p class="noindent">If you would like a smooth soup, purée with an immersion blender.</p>
</div>
<p class="breakhere"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 013-chapter7.vue?69060584